// extracted by mini-css-extract-plugin
export default {"root":"ChipInputTexrtField_root__vHZwp"};